import styles from './SectionIntroductionText.module.css';

type SectionIntroductionTextProps = {
  text: string;
};

export const SectionIntroductionText = ({ text }: SectionIntroductionTextProps) => {
  return <p className={styles.sectionIntroductionText}>{text}</p>;
};
